// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;






// import React, { useState } from 'react';

// function App() {
//   const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
//   const [status, setStatus] = useState('');

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   try {
//   //     const response = await fetch('https://script.google.com/macros/s/AKfycbx59tCANzvGqHMTOAe_aOX-TfL0KgWsVZSMUVqrVIf5aQVEAHj7UAKjNhy2fer4YUOI/exec', {
//   //       method: 'POST',
//   //       headers: { 'Content-Type': 'application/json' },
//   //       body: JSON.stringify(formData),
//   //     });
//   //     const result = await response.json();
//   //     setStatus(result.message);
//   //   } catch (error) {
//   //     console.error('Error:', error);
//   //     setStatus('Failed to send message. Try again later.');
//   //   }
//   // };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   try {
//   //     const response = await fetch('https://script.google.com/macros/s/AKfycbx59tCANzvGqHMTOAe_aOX-TfL0KgWsVZSMUVqrVIf5aQVEAHj7UAKjNhy2fer4YUOI/exec', {
//   //       method: 'POST',
//   //       headers: { 'Content-Type': 'application/json' },
//   //       body: JSON.stringify({
//   //         uniqueId: Date.now().toString(),
//   //         yourName: formData.name,
//   //         yourEmail: formData.email,
//   //         phone: formData.phone,
//   //         yourMessage: formData.message,
//   //         timestamp: new Date().toISOString(),
//   //       }),
//   //     });
//   //     const result = await response.text();
//   //     setStatus(result);
//   //   } catch (error) {
//   //     console.error('Error:', error);
//   //     setStatus('Failed to send message. Try again later.');
//   //   }
//   // };


//   const handleSubmit = async (e) => {
//     e.preventDefault();
  
//     try {
//       const response = await fetch('https://script.google.com/macros/s/AKfycbwCZuSX6zo6m3p4I7ZA5hAp2P5UaVvXmRD1JrE5oBA9YWaPu6ocFQFmLX2PxTypgqSWHw/exec', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           uniqueId: Date.now().toString(), // Example unique identifier
//           yourName: formData.name,
//           yourEmail: formData.email,
//           phone: formData.phone,
//           yourMessage: formData.message,
//           timestamp: new Date().toISOString(),
//         }),
//       });
  
//       const result = await response.json();
//       setStatus(result.message || 'Form submitted successfully!');
//     } catch (error) {
//       console.error('Error:', error);
//       setStatus('Failed to submit the form. Please try again.');
//     }
//   };

//   return (
//     <div>
//       <section>
//         <h1>Welcome to Virtual Showroom</h1>
//         <p>This is a virtual space to showcase your products or services.</p>
//       </section>
//       <section>
//         <h2>Contact Us</h2>
//         <form onSubmit={handleSubmit}>
//           <input
//             type="text"
//             name="name"
//             placeholder="Your Name"
//             value={formData.name}
//             onChange={handleChange}
//             required
//           />
//           <input
//             type="email"
//             name="email"
//             placeholder="Your Email"
//             value={formData.email}
//             onChange={handleChange}
//             required
//           />
//           <input
//             type="phone"
//             name="phone"
//             placeholder="Your phone number"
//             value={formData.phone}
//             onChange={handleChange}
//             required
//           />
//           <textarea
//             name="message"
//             placeholder="Your Message"
//             value={formData.message}
//             onChange={handleChange}
//             required
//           />
//           <button type="submit">Send</button>
//         </form>
//         {status && <p>{status}</p>}
//       </section>
//     </div>
//   );
// }

// export default App;








// import React, { useState } from 'react';

// function App() {
//   const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
//   const [status, setStatus] = useState('');

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const response = await fetch(   //Google Sheet Name: Test_singlepagewebsite_json (tech@mrarvr.in)
//         'https://script.google.com/macros/s/AKfycbxOQCbwrvmobUeS3y89TvS2n1yL-U3IOEYl5gS_tI3KalN6lXstmh933l9X82AQAAAD/exec',  
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'Accept': 'application/json',
//           },
//           body: JSON.stringify({
//             uniqueId: Date.now().toString(), // Generate a unique ID
//             name: formData.name,
//             email: formData.email,
//             phone: formData.phone,
//             message: formData.message,
//             timestamp: new Date().toISOString(),
//           }),
//         }
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const result = await response.text(); // Google Apps Script often returns plain text
//       setStatus(result || 'Form submitted successfully!');
//     } catch (error) {
//       console.error('Error:', error);
//       setStatus('Failed to submit the form. Please try again.');
//     }
//   };

//   return (
//     <div>
//       <section>
//         <h1>Welcome to Virtual Showroom</h1>
//         <p>This is a virtual space to showcase your products or services.</p>
//       </section>
//       <section>
//         <h2>Contact Us</h2>
//         <form onSubmit={handleSubmit}>
//           <input
//             type="text"
//             name="name"
//             placeholder="Your Name"
//             value={formData.name}
//             onChange={handleChange}
//             required
//           />
//           <input
//             type="email"
//             name="email"
//             placeholder="Your Email"
//             value={formData.email}
//             onChange={handleChange}
//             required
//           />
//           <input
//             type="tel"
//             name="phone"
//             placeholder="Your Phone Number"
//             value={formData.phone}
//             onChange={handleChange}
//             required
//           />
//           <textarea
//             name="message"
//             placeholder="Your Message"
//             value={formData.message}
//             onChange={handleChange}
//             required
//           />
//           <button type="submit">Send</button>
//         </form>
//         {status && <p>{status}</p>}
//       </section>
//     </div>
//   );
// }

// export default App;


















// import React from 'react'

// function FormToSheet() {

//   const handleSubmit = (e)=>{   //Google sheet name: VirtualShowroom_Website_Datasheet_2 (tech@mrarvr.in)
//     e.preventDefault()
//     const url = "https://script.google.com/macros/s/AKfycbyUEPyEqE-ZUYozi09JBLZveCLspSSTYhX-mkzBViE9uWzROrVUcJBLg8pCiwkyY1vkeg/exec"
//     fetch(url,{
//       method:"POST",
//       headers: { "Content-Type": "application/x-www-form-urlencoded" },
//       body:(`Name=${e.target.name.value}&Email=${e.target.email.value}&Phone=${e.target.phone.value}&Message=${e.target.message.value}`)
//     }).then(res=>res.text()).then(data=>{
//       alert(data)
//     }).catch(error=>console.log(error))
//   }

//   return (
//     <div>
//         <h1>React to Sheet</h1>
//         <form onSubmit={handleSubmit}>
//           <input name='name' placeholder='Name' /> <br/>
//           <input name='email' placeholder='Email' /> <br/>
//           <input name='phone' placeholder='Phone Number' /> <br/>
//           <input name='message' placeholder='Message here' /> <br/>
//           <button>Submit</button>
//         </form>
//     </div>
//   )
// }

// export default FormToSheet




import React, { useState, useEffect} from 'react';
import './App.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
// import { isValidPhoneNumber, getExampleNumber } from 'libphonenumber-js';
// import { isValidPhoneNumber } from 'libphonenumber-js';
import { parsePhoneNumberFromString } from 'libphonenumber-js'; // Import for phone validation

function FormToSheet() {
    const [formData, setFormData] = useState({
      name: '',
      email: '',
      organization: '',
      website: '',
      phone: '',
      category: '',
      message: ''
    });

    const [showPopup, setShowPopup] = useState(false); // State to control popup visibility
    const [error, setError] = useState(''); // State to manage error messages
    // const [errors, setErrors] = useState({}); // Track individual field errors

    // // Check screen resolution on component mount
    // useEffect(() => {
    //   const screenWidth = window.innerWidth;
    //   const screenHeight = window.innerHeight;
    //   console.log("Screen Resolution:", `${screenWidth}x${screenHeight}`);
    // }, []); // Empty dependency array ensures this runs only on mount

    // Check viewport resolution on component mount and window resize
    useEffect(() => {
      const logViewportResolution = () => {
          const viewportWidth = window.innerWidth;
          const viewportHeight = window.innerHeight;
          console.log("Viewport Resolution:", `${viewportWidth}x${viewportHeight}`);
      };

      // Log initial viewport resolution
      logViewportResolution();

      // Add event listener for window resize
      window.addEventListener('resize', logViewportResolution);

      // Cleanup event listener on unmount
      return () => window.removeEventListener('resize', logViewportResolution);
    }, []); // Empty dependency array ensures this runs only on mount


    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: value
      }));

      // Clear error message as soon as the user starts typing
      if (error) {
        setError('');
      }
      
      // Clear the error for the field when the user starts typing
      // setErrors((prevErrors) => ({
      //   ...prevErrors,
      //   [name]: ''
      // }));

    };

    const handlePhoneChange = (phone, countryData) => {
      setFormData((prevData) => ({
        ...prevData,
        phone
      }));
      if (error) {
        setError('');
      }
    };

    
    /*const validateForm = () => {
      // const newErrors = {};
      if (!formData.name.trim()) {
        // newErrors.name = 'Name is required.';
        return "Name is required.";
      }
      if (!formData.email.trim()) {
        // newErrors.email = 'Email is required.';
        return "Email is required.";
      }
      if (!formData.phone.trim()) {
        // newErrors.phone = 'Phone number is required.';
        return "Phone number is required.";
      }
      // Add more validations as needed, e.g., email format, phone format, etc.
      return '';
      // return newErrors;
    };*/

    /*const validateForm = () => {
      const errorMessages = [];
  
      if (!formData.name.trim()) {
        errorMessages.push("Name is required.");
      }
      if (!formData.email.trim()) {
        errorMessages.push("Email is required.");
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)) {
        errorMessages.push("Invalid email format.");
      }
      if (!formData.phone.trim()) {
        errorMessages.push("Phone number is required.");
      } else if (!/^\d{10}$/.test(formData.phone)) {
        errorMessages.push("Phone number must be 10 digits.");
      }
  
      return errorMessages;
    };*/

    const validateForm = () => {
      if (!formData.name.trim()) {
        return "Name is required.";
      }
      if (!formData.email.trim()) {
        return "Email is required.";
      } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {      //else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)) {
        return "Invalid email format.";
      }
      if (!formData.organization.trim()) {
        return "Company Name is required.";
      }
      if (!formData.website.trim()) {
        return "Website is required.";
      } else if (
        !/^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(:\d+)?(\/.*)?$/.test(formData.website)) {
        return "Invalid website URL.";
      }
      if (!formData.phone.trim()) {
        return "Phone number is required.";
      } /*else if (!/^\d{10}$/.test(formData.phone)) {
        return "Phone number must be 10 digits.";
        }*/
        // else if (!isValidPhoneNumber(formData.phone)) {
        //   return 'Invalid phone number.';
        // }
      else {
        const phoneNumber = parsePhoneNumberFromString(formData.phone, 'IN'); // Replace 'IN' with default country
        if (!phoneNumber || !phoneNumber.isValid()) {
            return "Invalid phone number.";
        }
      }

      if (!formData.category.trim()) {
        return "Category is required.";
      }
      if (!formData.message.trim()) {
        return "Please fill the Requiment.";
      }
      return ''; // No errors
    };


  const handleSubmit = (e) => {
    e.preventDefault();   //Google sheet name: VirtualShowroom_Website_Datasheet_2 (tech@mrarvr.in)
    
    /*const validationError = validateForm();
    if (validationError) {
      setError(validationError); // Display error message
      return; // Stop form submission
    }*/

    /*const validationErrors = validateForm();
    if (validationErrors.length > 0) {
      setError(validationErrors.join(' ')); // Show all error messages in one place
      return; // Stop form submission
    }*/

    const validationError = validateForm();
    if (validationError) {
      setError(validationError); // Show only the first error
      return; // Stop form submission
    }

    // const validationErrors = validateForm();
    // if (Object.keys(validationErrors).length > 0) {
    //   setErrors(validationErrors); // Set errors for each field
    //   return; // Stop form submission
    // }

    setError(''); // Clear previous error
    // setErrors({}); // Clear errors if form is valid
    const url = "https://script.google.com/macros/s/AKfycbyEGa72aff3PZm75WQ2DHH5FKHEVUnjdFb9LEdmIC6YaRUgQwetFlGoRkMuJ9f41fRNGA/exec";
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: (
        `Name=${e.target.name.value}&Email=${e.target.email.value}&Organization=${e.target.organization.value}&Website=${e.target.website.value}&Phone=${e.target.phone.value}&Category=${e.target.category.value}&Message=${e.target.message.value}`
      )
    }).then(res => res.text()).then(data => {
      // alert(data);
      console.log(data);
        // Show popup dialog on success
        setShowPopup(true);

      // Clear the form fields after submission
      setFormData({
        name: '',
        email: '',
        organization: '',
        website: '',
        phone: '',
        category: '',
        message: ''
      });

    }).catch(error => console.log(error));
  };

  const handleClosePopup = () => {
    setShowPopup(false); // Close the popup
  };

  return (
    // <div className="app-container">
    //   <video autoPlay loop muted className="background-video">
    //     <source src="/videos/VRARMR_Metaverse_Teaser_compressed.mp4" type="video/mp4" />
    //     Your browser does not support the video tag.
    //   </video>
    //   <div className="content-grid">
    //     <div className="text-column">
    //       <h1>Welcome to Meta Showroom</h1>
    //       <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent convallis ultricies ex, a volutpat ligula gravida vel. Integer ac sollicitudin orci. Vivamus non purus at lacus suscipit placerat.</p>
    //     </div>
    //     <div className="form-column">
    //       <h2>Contact Us</h2>
    //       {/*error && <p className="error-message">{error}</p>*/} {/* Display error message */}
    //       <form onSubmit={handleSubmit} className="form">
    //         <input name="name" placeholder="Name*" value={formData.name} onChange={handleChange} className="input" /> 
    //         {errors.name && <p className="error-message">{errors.name}</p>}
    //         <br />
    //         <input name="email" placeholder="Email*" value={formData.email} onChange={handleChange} className="input" /> 
    //         {errors.email && <p className="error-message">{errors.email}</p>}
    //         <br />
    //         <input name="phone" placeholder="Phone Number*" value={formData.phone} onChange={handleChange} className="input" /> 
    //         {errors.phone && <p className="error-message">{errors.phone}</p>}
    //         <br />
    //         <input name="organization" placeholder="Organization" value={formData.organization} onChange={handleChange} className="input" /> <br />
    //         <textarea name="message" placeholder="Message here" value={formData.message} onChange={handleChange} className="textarea"></textarea> <br />
    //         <button className="submit-button">Submit</button>
    //       </form>
    //     </div>
    //   </div>

    <div className="app-container">
    <video autoPlay loop muted className="background-video">
      <source src="/videos/VRARMR_Metaverse_vid_Teaser_for_web_2_compressed.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <div className="left-container">
      {/* <h1>Welcome to Meta Showroom</h1>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent convallis ultricies ex, a volutpat ligula gravida vel. Integer ac sollicitudin orci. Vivamus non purus at lacus suscipit placerat.</p> */}
      <div className="content-box">
        {/* <img id="logo_img" src="/VRARMR_logo_W_new_1.png" alt='images'></img> */}
        <h1>Virtual Showroom Beta Now Available!</h1>
        <h5>Web + Mobile-First AI 3D Brand Showroom</h5>
        <p>Imagine a showroom where your brand isn’t just seen, it’s experienced where 
          your products come to life in a multi-dimensional space, inviting customers 
          to engage in a way that feels deeply personal and unforgettable. Every interaction
           here, is crafted to engage the senses, stimulating not just the eyes, but the 
           mind. Customers here will experience a sense of immersion so real, it’s as if 
           they’re touching your products. This will be so captivating that they’ll tell 
           their friends about it and that’s the kind of marketing money can’t buy. </p>
        <h6>Why you need this now: </h6>
          <div className="content-box_list">
            <div>
              <li>No more flat, lifeless 2D images</li>
              <li>Grab attention, stand out from the crowd</li>
            </div>
            <div>
              <li>Engage and retain customers</li>
              <li>Control every detail, reflecting brand’s identity</li>
            </div>
          </div>
      </div>
    </div>
    <div className="right-container">
      {/* <h2>Contact Us</h2>
      <form onSubmit={handleSubmit} className="form">
        <input name="name" placeholder="Name*" value={formData.name} onChange={handleChange} className="input" />
        {errors.name && <p className="error-message">{errors.name}</p>}
        <input name="email" placeholder="Email*" value={formData.email} onChange={handleChange} className="input" />
        {errors.email && <p className="error-message">{errors.email}</p>}
        <input name="phone" placeholder="Phone Number*" value={formData.phone} onChange={handleChange} className="input" />
        {errors.phone && <p className="error-message">{errors.phone}</p>}
        <input name="organization" placeholder="Organization" value={formData.organization} onChange={handleChange} className="input" />
        <textarea name="message" placeholder="Message here" value={formData.message} onChange={handleChange} className="textarea"></textarea>
        <button className="submit-button">Submit</button>
      </form> */}

      {/* Separated error messages with each required fields*/}
      {/* <div className="form-background">
        <h2>CONTACT US</h2>
        <form onSubmit={handleSubmit} className="form">
          <input name="name" placeholder="Name*" value={formData.name} onChange={handleChange} className="input" />
          {errors.name && <p className="error-message">{errors.name}</p>}
          <input name="email" placeholder="Email*" value={formData.email} onChange={handleChange} className="input" />
          {errors.email && <p className="error-message">{errors.email}</p>}
          <input name="phone" placeholder="Phone Number*" value={formData.phone} onChange={handleChange} className="input" />
          {errors.phone && <p className="error-message">{errors.phone}</p>}
          <input name="organization" placeholder="Organization" value={formData.organization} onChange={handleChange} className="input" />
          <textarea name="message" placeholder="Message here" value={formData.message} onChange={handleChange} className="textarea"></textarea>
          <button className="submit-button">Submit</button>
        </form>
      </div> */}

      <div className="form-background">
        {/*error && <p className="error-message">{error}</p>*/} {/* Display error message */}
        {error && (
          <p className="error-message">
              <img id="closepng_img" src="Close.png" alt="Close icon" /> {error}
          </p>
        )}
        <h2>Onboarding Form</h2> 
        <h4>Transform your approach with a compelling immersive experience that captures attention, drives conversions and delivers remarkable results.</h4>
           <form onSubmit={handleSubmit} className="form" autocomplete="off">
             <input name="name" placeholder="Name*" value={formData.name} onChange={handleChange} className="input" /> 
             {/* {errors.name && <p className="error-message">{errors.name}</p>} */}
             <br />
             <input name="email" placeholder="Email*" value={formData.email} onChange={handleChange} className="input" /> 
             {/* {errors.email && <p className="error-message">{errors.email}</p>} */}
             <br />
             <input name="organization" placeholder="Company Name*" value={formData.organization} onChange={handleChange} className="input" /> <br />
             <input name="website" placeholder="Website*" value={formData.website} onChange={handleChange} className="input" /> <br />
             {/* <input name="phone" placeholder="Phone Number*" value={formData.phone} onChange={handleChange} 
                onKeyDown={(e) => {
                  if (
                    !/^[0-9]$/.test(e.key) && // Allow only numbers
                    e.key !== "Backspace" && // Allow backspace
                    e.key !== "Delete" && // Allow delete
                    e.key !== "ArrowLeft" && // Allow left arrow
                    e.key !== "ArrowRight" // Allow right arrow
                  ) {
                    e.preventDefault(); // Block other keys
                  }
                }}
              className="input" />  */}
             {/* {errors.phone && <p className="error-message">{errors.phone}</p>} */}
             <br />
             <PhoneInput
              country={'in'}
              value={formData.phone}
              onChange={handlePhoneChange}
              enableSearch={true}
              autoFormat={true}
              international={true}
              countryCodeEditable={false}
              placeholder="Phone number"
              inputProps={{
                name: 'phone',
                required: true,
              }}
              className="input"
            />
            <br />

             <input name="category" placeholder="Category*" value={formData.category} onChange={handleChange} className="input" /> <br />
             <textarea name="message" placeholder="Requirement*" value={formData.message} onChange={handleChange} className="textarea"></textarea> <br />
             <button className="submit-button">SUBMIT</button>
           </form>
      </div>

      <div className="footer-text-mobile">
        All you’ve got to do is envision your space while we handle the complex coding and technicalities.
      </div>
    </div>

      {/* Popup Dialog */}
      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <h3>THANK YOU!</h3>
            <p>Your data has been submitted successfully.</p>
            <button className="popup-button" onClick={handleClosePopup}>
              OK
            </button>
          </div>
        </div>
      )}

      {/* Add iframe here */}
      {/* <iframe id="myIframe" src="https://3dchatbot-test.netlify.app" allow="microphone"></iframe> */}

      <div className="footer-text">
        All you’ve got to do is envision your space while we handle the complex coding and technicalities.
      </div>
    </div>
    
  );
}

export default FormToSheet;





////////////



/////The below is fine with the simple method/////////
// import "./styles.css";

// export default function App() {
//   function Submit(e) {
//     const formEle = document.querySelector("form");
//     const formDatab = new FormData(formEle);
//     fetch(       //Google Sheet name: Virtual-Showroom-Singlepage-website-Data (tech@mrarvr.in)
//       "https://script.google.com/macros/s/AKfycbyIwQbkepMPpiWK0qtDdhzZmy7IWIdhaJyUnfaG3thtEUrvrw3rnnlkRRsxct3TogY1/exec",
//       {
//         method: "POST",
//         body: formDatab
//       }
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         console.log(data);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   }
//   return (
//     <div className="App">
//       <h1>Contact Me form</h1>
//       <h2>
//         This demonstrates how to send data from a website form to Google sheet
//         in React or Vanilla jS
//       </h2>
//       <div>
//         <form className="form" onSubmit={(e) => Submit(e)}>
//           <input placeholder="Your Name" name="Name" type="text" />
//           <input placeholder="Your Email" name="Email" type="text" />
//           <input placeholder="Your Message" name="Message" type="text" />
//           <input name="Name" type="submit" />
//         </form>
//       </div>
//     </div>
//   );
// }

